import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';

const LinkedInAgeRanges = {
  EighteenToTwentyFive: _TL_('18 to 24'),
  TwentyFiveToThirtyFive: _TL_('25 to 34'),
  ThirtyFiveToFiftyFive: _TL_('35 to 54'),
  FiftyFiveAndAbove: _TL_('55+'),
};

const Genders = {
  Female: _TL_('Female'),
  Male: _TL_('Male'),
};

export class ColumnDemographic extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const localizedTitle = i18n.getString('CampaignSettingsGrid_ColumnHeader_Demographics');

    super({
      name: 'Demographic',
      type: 'string',
      property: 'CampaignCriterions',
      sortable: false,
      title: 'CampaignSettingsGrid_ColumnHeader_Demographics',
      helpId: 'Page_CampaignGrids_Demographic',
      i18n,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
  }

  get property() {
    return {
      get: ({ CampaignCriterions, CampaignType }) => {
        if (CampaignType === 'LinkedIn') {
          const ages = _.filter(CampaignCriterions, criterion => criterion.Criterion.Type === 'Age')
            .map(criterion => LinkedInAgeRanges[criterion.Criterion.AgeRange] || criterion.Criterion.AgeRange);
          const genders = _.filter(CampaignCriterions, criterion => criterion.Criterion.Type === 'Gender')
            .map(criterion => Genders[criterion.Criterion.GenderType] || criterion.Criterion.GenderType);
          const isAllAges = _.isEmpty(ages) || _.size(ages) === _.size(LinkedInAgeRanges);
          const isAllGenders = _.isEmpty(genders) || _.size(genders) === _.size(Genders);

          const genderListString = isAllGenders
            ? this.i18n.getString(_TL_('Both genders'))
            : _.chain(_.sortBy(genders))
              .map(gender => this.i18n.getString(gender))
              .join(this.i18n.getString(_TL_(', ')))
              .value();

          const ageRangesListString = isAllAges
            ? this.i18n.getString(_TL_('all ages'))
            : _.chain(_.sortBy(ages))
              .map(ageRange => this.i18n.getString(ageRange))
              .join(this.i18n.getString(_TL_(', ')))
              .value();

          if (isAllAges && isAllGenders) {
            return this.i18n.getString('Page_PFPCampaignOrder_AllDemogExcerpt');
          }

          return [genderListString, ageRangesListString].join(this.i18n.getString(_TL_(', ')));
        }

        return this.i18n.getString('Page_PFPCampaignOrder_AllDemogExcerpt');
      },
      key: this.config.property,
    };
  }
}
